import { gql } from 'apollo-angular';
import { PRODUCT_FRAGMENT } from './product-fragment';
export const getCollectionProductsByHandle = /* GraphQL */ gql`
    ${PRODUCT_FRAGMENT}
    query GetCollectionProductsByHandle($handle: String, $first: Int, $after: String) {
        collection(handle: $handle) {
            title
            metafields(
                identifiers: [
                    { namespace: "custom", key: "display_name" }
                    { namespace: "custom", key: "subtitle" }
                ]
            ) {
                key
                value
                updatedAt
            }
            products(first: $first, after: $after, sortKey: MANUAL) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        ...ProductFields
                    }
                }
            }
        }
    }`;